import { AuthContextInterface } from "../contexts/auth";
import { UserObject } from "../models/User";
import serviceFetch from "./fetch";

export const getCurrentUser = async (
  auth: AuthContextInterface
): Promise<{ data: UserObject }> => serviceFetch(auth, "user", null, "get");
